module.exports = __webpack_public_path__ + "img/homebg05.41025ace.svg";